// frontend/src/services/authService.js
import axios from "axios";
import { API_URL } from "../config";

export const register = async (email, password, fullName, role) => {
  const response = await axios.post(`${API_URL}/users/register`, {
    email,
    password,
    full_name: fullName,
    role,
  });
  return response.data; // { id, email, full_name, role }
};

export const login = async (email, password) => {
  const response = await axios.post(`${API_URL}/users/login`, {
    email,
    password,
  });
  // { access_token: "xxxx", token_type: "bearer" }
  return response.data;
};

export const getMe = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token found");
  const response = await axios.get(`${API_URL}/users/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data; // {id, email, role, ...}
};